import React, { Component } from 'react';

class NameEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editable: false,
      name: this.props.product.name,
      nameCN: this.props.product.nameCN,
    };
  }

  showNameEditor() {
    this.setState((prevState) => {
      return { editable: !prevState.editable }
    });
  }

  cancelEdit() {
    this.setState({ editable: false });
  }

  rename(event) {
    this.setState({ nameCN: event.target.value });
  }

  saveAndRename() {
    this.props.saveAndRename({ nameCN: this.state.nameCN }, () => {
      this.setState({ editable: false });
    });
  }

  render() {
    const inputStyle = this.state.editable ? 'input-group mb-2' : 'input-group mb-2 d-none';
    return (
      <div>
        <h5 className='mt-0' onClick={ () => this.showNameEditor() }>
          { this.state.name } <span className="oi oi-pencil text-info ml-3 edit-pencil"></span>
        </h5>
        <h5 className='prod-name-cn' onClick={ () => this.showNameEditor() }>
          { this.state.nameCN }
        </h5>

        <div className={ inputStyle }>
          <input type="text" className="form-control"
            onChange={ this.rename.bind(this) }
            value={ this.state.nameCN } />
          <div className="input-group-append">
            <button className="btn btn-outline-secondary"
              type="button"
              onClick={ this.cancelEdit.bind(this) }>Cancel</button>
            <button className="btn btn-info"
              type="button"
              onClick={ this.saveAndRename.bind(this) }>Save</button>
          </div>
        </div>
      </div>
    );
  }
}

export default NameEditor;
